import React from 'react';
import CardShell from '@/components/CardShell';
import Spinner from '@/components/Spinner';
import VerifyScreen from '@/screens/VerifyScreen';
import DeadLinkScreen from '@/screens/DeadLinkScreen';
import InvoiceRedirectScreen from '@/screens/InvoiceRedirectScreen';
import useHostedEntry from './useHostedEntry';
import session from '@/session';

/**
 * The /invoice flow: same conditional-verify entry, then straight to the
 * Stripe-hosted invoice page for the oldest open invoice.
 */
const InvoiceFlow = () => {
	const entry = useHostedEntry();

	const body = () => {
		if (entry.phase === 'dead') return <DeadLinkScreen variant={entry.deadVariant} />;
		if (entry.phase === 'verify') {
			return (
				<VerifyScreen
					context={entry.context}
					onSubmit={entry.verify}
					error={entry.verifyError}
					busy={entry.verifyBusy}
					notice={entry.notice}
				/>
			);
		}
		if (entry.phase === 'loading') return <Spinner label="Loading…" />;

		return (
			<InvoiceRedirectScreen studentId={session.get()?.student_id} studentName={entry.context?.student_first_name} />
		);
	};

	return <CardShell>{body()}</CardShell>;
};

export default InvoiceFlow;
